import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ConfirmResendIODialog from '../../components/ConfirmResendIODialog';
import { resendIo } from '../../sources/io';
import { resendToIOPartner } from '../queryKeyFactory';

export const useResendIoToPartner = () => {
  const showModal = useScreenModalV2(ConfirmResendIODialog);

  const resendIoToPartnerMutation = useMutation(resendToIOPartner(), resendIo, {
    successMessage: () => 'IO resent',
  });

  const handleResendIO = async (io) => {
    const { id } = io;

    const data = await showModal({
      io,
    });

    await resendIoToPartnerMutation.mutateAsync({ id, ...data });
  };

  return [handleResendIO, resendIoToPartnerMutation];
};
